package pl.decks.chartjs.radar.options

import pl.decks.chartjs.color.ChartColor
import pl.decks.chartjs.jsConstructors.jso
import pl.decks.chartjs.model.ChartJSOption
import pl.decks.chartjs.model.JSScriptable
import pl.decks.chartjs.model.JSScriptableIndexable

data class AngleLineOptions(
    val display: Boolean = true,
    val color: JSScriptableIndexable<ChartColor>? = null,
    val lineWidth: JSScriptable<Float>? = null,
    val borderDash: JSScriptable<List<Int>>? = null,
    val borderDashOffset: JSScriptable<Float>? = null,
) : ChartJSOption {
    override fun toChartJs(): dynamic = jso {
        this.display = display.asDynamic()
        if (color != null) this.color = color.toChartJs { it.toChartJs() }
        if (lineWidth != null) this.lineWidth = lineWidth.toChartJs { it.asDynamic() }
        if (borderDash != null) this.borderDash = borderDash.toChartJs { it.toTypedArray().asDynamic() }
        if (borderDashOffset != null) this.borderDashOffset = borderDashOffset.toChartJs { it.asDynamic() }
    }
}
